import {Injectable} from '@angular/core';
import {GLOBAL} from '../global';
import {User} from '../model/user.entity';
import {distinctUntilChanged} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';
import {takeUntil, skip, map} from 'rxjs/operators';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {getSubOrgByState} from '../sub-organisation';

export interface SubOrganisation {
  id: string;
  name: string;
}

const DefaultFilter = {id: '', name: 'ALL'};

const DSQSubOrganisations = [
  {id: 'deaf-services', name: 'QLD'},
  {id: 'deaf-society', name: 'NSW'},
  {id: 'deaf-global', name: 'ALL'},
];

const AllowedUserTypes = ['BookingOfficer', 'Administrator'];

@Injectable()
export class SubOrganisationFilterService {
  get list() {
    return DSQSubOrganisations;
  }

  get unselectedList() {
    return DSQSubOrganisations.filter((subOrganisation) => subOrganisation !== this.selected);
  }

  private _selectedValue: SubOrganisation = DefaultFilter;
  private _selected: BehaviorSubject<SubOrganisation> = new BehaviorSubject(this._selectedValue);
  get selected() {
    return this._selectedValue;
  }
  get selected$() {
    return this._selected.asObservable().pipe(distinctUntilChanged()) as Observable<SubOrganisation>;
  }

  constructor() {
    GLOBAL.currentUser$
      .pipe(
        map((user: User) => user && getSubOrgByState(user.state_where_most_bookings_occur)),
        distinctUntilChanged()
      )
      .subscribe((subOrg: string) => this.selectByName(subOrg));
  }

  isVisibleToUser(user: User) {
    return AllowedUserTypes.includes(user.type) && user.business_name === 'DSQ';
  }

  select(subOrganisation: SubOrganisation) {
    this._selectedValue = subOrganisation;
    this._selected.next(subOrganisation);
  }

  private selectByName(name: string) {
    this.select(this.list.find((subOrganisation) => subOrganisation.name === name) || DefaultFilter);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sub-organisation-filter/sub-organisation-filter.service.ts